// Import our custom CSS
import './scss/style.scss';

// Import all of Bootstrap's JS
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import './js/utils/restore-scroll';
import './js/global';

// utils
import './js/utils/close-dialog';
import './js/utils/equalize-heights';
import './js/utils/image-slider';
import './js/utils/login-link-class';
import './js/utils/button-status-text';
import './js/utils/scroll-to-error.js';
import './js/utils/resize-vertical-mobile.js';

// analytics
import './js/analytics/analytics-conditional-formatting';
import './js/analytics/mat-placeholder-table';

// assignments
import './js/assignments/annotations';
import './js/assignments/assignment-image-input-logic';
import './js/assignments/assignments-table-linked';
import './js/assignments/bookshelf-select';
import './js/assignments/class-students-status';
import './js/assignments/olexinstant.js';
import './js/assignments/subject-change-bg';
import './js/assignments/toggle-olexai-cards-view';
import './js/assignments/analytics-table';
import './js/assignments/toggle-feedback';


// forms
import './js/forms/accounts-pages';
import './js/forms/plume-commands';
import './js/forms/schools-pages';
import './js/forms/assignments-form';

// modules
import './js/modules/faceted-views';
import './js/modules/grid-item-select';
import './js/modules/modal';
import './js/modules/question-item';

// navigation
import './js/navigation/active-navigation-links';
import './js/navigation/mobile-burger-menu.js';
import './js/navigation/modules-subnavigation';
import './js/navigation/navbar-scroll';

// question modal
import './js/question-modal/quiz-mobile-header';
import './js/question-modal/math-tabs-restrictions';
import './js/question-modal/latex-answer-buttons';
import './js/question-modal/scroll-top';
import './js/question-modal/whitepaper';
import './js/question-modal/self-mark-input';
import './js/question-modal/overlay-links';
import './js/question-modal/question-modal';
